import { Box, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

interface TextFieldReadOnlyProps extends PropsWithChildren{
  label: string;
}

const TextFieldReadOnly = (props: TextFieldReadOnlyProps) => {
  return (
    <Box mt={2}>
      <Typography variant="caption" color="gray">{props.label}</Typography>
      <div>{props.children}</div>
    </Box>
  )
};

export default TextFieldReadOnly;
